fx.ns("filters", class ThemeCoverFilter extends fx.Filter {

	constructor(theme_tag_id, model, showMinAndMore, themeid, is3D)
	{
        super();
        this._model = model;
        this._theme_tag_id = theme_tag_id;
        this._themeid = themeid;
        this._search = "themes";
        this._showMinAndMore = showMinAndMore;
        this._is3D = is3D
        this._proposedFirst = false;
    }

    /**
     * The covers proposed for the album (LayoutsRepository.proposedCovers) shown instead of the
     * themes when there are some (search "themes", the "Thématique" tab of the layouts panels).
     */
    get proposedFirst()
    {
        return this._proposedFirst;
    }

    set proposedFirst(val)
    {
        this._proposedFirst = val;
        this._changed = true;
        this.trigger("updated");
    }

    get theme_tag_id()
    {
        return this._theme_tag_id;
    }

    set theme_tag_id(val)
    {
        this._theme_tag_id = val;
        this._changed = true;
        this.trigger("updated");
    }

    get search()
    {
        return this._search;
    }

    set search(val)
    {
        this._search = val;
        this._changed = true;
        this.trigger("updated");
    }

    
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        if (this._is3D)
        {
            for (let i = 0; i <this.rawData.layouts.length; i++)
            {
                let layout =this.rawData.layouts.getItemAt(i);
                
                if ( layout.num_photos == 1 && layout.themeid == this._themeid && !layout.accountid && layout.target == "")
                    this.transformedData.push( layout );
            }

            this.transformedData = this._uniqueLayouts(this.transformedData);
        }
        else
        if (this.search == "themes")
        {
            for (let i = 0; i < this.rawData.themes.length; i++)
            {
                let theme = this.rawData.themes.getItemAt(i);
            
                if (theme.theme_tag_id == this._theme_tag_id)
                    this.transformedData.push( theme );
            }

            if (fx.browser.isDesktop)
                this.transformedData.push({type : "label", text : fx.text("Changer de Thématique") } )
        }
        else
        if (this.search == "custom")
        {
            for (let i = 0; i <this.rawData.layouts.length; i++)
            {
                let layout =this.rawData.layouts.getItemAt(i);
                if (layout.themeid == -1 && layout.accountid)
                    this.transformedData.push( layout );
            }
        }
        else
        {
            for (let i = 0; i <this.rawData.layouts.length; i++)
            {
                let layout =this.rawData.layouts.getItemAt(i);
                
                if (this._showMinAndMore)
                {
                    let num = (this.search > 4) ? 4 : this.search;

                    if ( layout.num_photos >= num && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                if(this.search == 1)
                {
                    if ( layout.num_photos <= 1 && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                if(this.search == "+") 
                {
                    if ( layout.num_photos > 4 && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                {
                    if ( layout.num_photos == this._search && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
            }
        }

        if (this._showMinAndMore)
            this.transformedData = this.transformedData.sort(function(a, b){ return (a.num_photos - b.num_photos) });

        // an album whose category was detected : its covers only (the place, then the category),
        // the themes of the tag no longer shown ; the "Changer de Thématique" link stays
        if (this._proposedFirst && this.search == "themes" && !this._is3D)
        {
            let proposed = this._proposedCovers();

            if (proposed.length)
                this.transformedData = proposed.concat(this.transformedData.filter((item) => item && item.type == "label"));
        }

		return this.transformedData;
	}	

    _proposedCovers()
    {
        let layouts = this.rawData.layouts;

        return (layouts && layouts.hasProposedCovers) ? layouts.proposedCovers : [];
    }


    _uniqueLayouts( layouts )
    {
        let uniqueLayouts = [];
        const seenLayouts = new Set();
    
        layouts.forEach(layout => {

            if (layout.doublepage)
                return;

            let components = layout.components.sort( (a, b) => a.x - b.x || a.y - b.y );

            let key = "";
            components.forEach( component => {
                if (component.component_type != "background")
                    key += `${Math.round(component.x)}|${Math.round(component.y)}|${Math.round(component.width)}|${Math.round(component.height)}|`;
            });

            if (!seenLayouts.has(key)) {
                seenLayouts.add(key);
                uniqueLayouts.push(layout);
            }
        });

        return uniqueLayouts;
    }

});